import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core'
import { Observable, ReplaySubject, Subject, Subscription } from 'rxjs'
import { switchMap, take, tap } from 'rxjs/operators'
import { AttachmentComponent } from '../../../models/entity-configuration'
import { DtoType } from '../../../../../root-store/page-state-store/page-state.state'
import { EntityConfigService } from '../../../services/entity-config.service'

/** What does it do?
 * - this is just a wrapper component for EntityFieldGroupComponent
 * - it retrieves all visible fields for a given entity from store and passes them to EntityFieldGroupComponent
 * - EntityFieldGroupComponent then just displays them in a table
 */
@Component({
  selector: 'jml-lib-entity-header',
  templateUrl: './entity-header.component.html',
  styleUrls: ['./entity-header.component.scss']
})
export class EntityHeaderComponent implements OnInit, OnChanges, OnDestroy {
  /** still a bit unclear if this works here, needs to be checked and refactored */
  @Input() refreshTrigger: Subject<[string, number]>
  /** entity type, reqired to retrieve the entity config from store */
  // @Input() entityType: string;
  // @Input() id: number;
  @Input() configName: string
  /** id of the selected Entity */
  @Input() entryId: number
  /** fields to display */
  headerComponent: AttachmentComponent

  subscriptions: Subscription[] = []

  private _$configName: ReplaySubject<string> = new ReplaySubject<string>(1)

  constructor(private entityConfigService: EntityConfigService) {}

  ngOnInit(): void {
    const dtoType$: Observable<DtoType> = this._$configName.pipe(
      switchMap((configName) => this.entityConfigService.getDtoType$(configName)),
      tap((currentDtoType) => {
        this.configName = currentDtoType.config['type']
        this.headerComponent = {
          type: currentDtoType.config['type'],
          name: currentDtoType.config['name'],
          displayName: currentDtoType.config['displayName'],
          displayDescription: currentDtoType.config['displayDescription'],
          showCollapsed: currentDtoType.config['showCollapsed'],
          attachmentCategories: currentDtoType.config['attachmentCategories'],
          fields: currentDtoType.headerFields.map((field) => field.field)
        }
      }),
      take(1)
    )

    this.subscriptions.push(dtoType$.subscribe())
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.configName) {
      this._$configName.next(changes.configName.currentValue)
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe())
  }
}
